import { useState } from "react";
import styled from "styled-components";

import NavItem from "./NavItem";
import SettingsButton from "./SettingsButton";
import {
  SectionTabBar,
  SectionTabButton,
  SectionTabBarWrapper,
} from "./SectionTabBar";

export default function Database() {
  const [selectedItem, setSelectedItem] = useState(false);
  return (
    <Wrapper>
      <SectionTabBarWrapper>
        <SectionTabBar buttonsPerRow={4}>
          <SectionTabButton
            icon="fa-duotone fa-solid fa-mailbox-flag-up"
            title="My Notes"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
          <SectionTabButton
            icon="fa-duotone fa-solid fa-newspaper fa-swap-opacity"
            title="Latest"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
          <SectionTabButton
            icon="fa-duotone fa-solid fa-book-open-cover fa-swap-opacity"
            title="Library"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
          <SectionTabButton
            icon="fa-duotone fa-solid fa-chart-line-up "
            title="Unolytics"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
        </SectionTabBar>
      </SectionTabBarWrapper>

      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
      />
      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isGroup
      />
      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isGroup
      />
      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isGroup
      />
      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isGroup
      />
      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isGroup
      />
      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isGroup
      />
      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isGroup
      />
      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isGroup
      />
      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isGroup
      />
      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isGroup
      />
      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isGroup
      />
      <NavItem
        icon="fa-duotone fa-solid fa-users"
        title="Everyone"
        itemKey="famreg"
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isGroup
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-bottom: 12px;
  position: relative;
`;
const SettingsWrapper = styled.div`
  position: absolute;
  right: 4px;
  bottom: 4px;
`;
const IconHolder = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
`;
